import styled, { css } from "styled-components";
import { theme } from "../theme/lexusTheme";

export const Wrapper = styled.div`
    display: inline-flex;
    padding-left: ${theme.space[3]}px;
    padding-right: ${theme.space[6]}px;
    border-bottom: 1px solid ${theme.colors.grey2};
    @media print {
        display: none;
    }

    html[dir="rtl"] & {
        padding-left: ${theme.space[6]}px;
        padding-right: ${theme.space[3]}px;
    }
`;

export const Item = styled.div<{ active?: boolean }>`
    display: flex;
    position: relative;
    top: 1px;
    flex: 1;
    padding-bottom: ${theme.space[2]}px;
    font-family: ${theme.fonts.book};
    font-size: 1.6rem;
    line-height: 2.4rem;
    white-space: nowrap;
    border-bottom: 1px solid ${theme.colors.silver};
    transition: border 0.2s;
    cursor: pointer;

    &:first-child {
        margin-right: ${theme.space[3]}px;
    }

    ${({ active }) =>
        active &&
        css`
            font-family: ${theme.fonts.regular};
            border-color: ${theme.colors.azure};
        `};

    html[dir="rtl"] & {
        &:first-child {
            margin-left: ${theme.space[3]}px;
            margin-right: 0;
        }
    }
`;
